import React, { useState } from "react";
import { useAuth, apiError } from "@/context/AuthContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { KeyRound, ShieldAlert } from "lucide-react";

export default function ForcePinSetup() {
  const { refreshMe, logout } = useAuth();
  const [pin, setPin] = useState("");
  const [pin2, setPin2] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (!/^\d{4}$/.test(pin)) { toast.error("Il PIN deve avere esattamente 4 cifre"); return; }
    if (pin !== pin2) { toast.error("I due PIN non coincidono"); return; }
    setBusy(true);
    try {
      await api.post("/auth/pin", { pin });
      await refreshMe();
      toast.success("PIN impostato");
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-[hsl(var(--background))] flex items-center justify-center p-6" data-testid="force-pin-screen">
      <div className="w-full max-w-sm space-y-5 text-center">
        <div className="mx-auto h-14 w-14 rounded-2xl bg-sky-600 flex items-center justify-center">
          <ShieldAlert className="h-7 w-7 text-white" />
        </div>
        <div>
          <h1 className="text-xl font-bold">PIN obbligatorio</h1>
          <p className="text-sm text-muted-foreground mt-1">
            L'amministratore richiede un PIN di sblocco. Imposta ora un PIN di 4 cifre per continuare.
          </p>
        </div>
        <Input inputMode="numeric" maxLength={4} placeholder="Nuovo PIN" value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
          data-testid="force-pin-input" className="text-center tracking-[0.3em] text-lg" />
        <Input inputMode="numeric" maxLength={4} placeholder="Ripeti PIN" value={pin2}
          onChange={(e) => setPin2(e.target.value.replace(/\D/g, "").slice(0, 4))}
          data-testid="force-pin-confirm" className="text-center tracking-[0.3em] text-lg" />
        <Button onClick={save} disabled={busy} className="w-full bg-sky-600 hover:bg-sky-700 text-white" data-testid="force-pin-save">
          <KeyRound className="h-4 w-4 mr-2" /> Imposta PIN e continua
        </Button>
        <button onClick={logout} className="text-xs text-muted-foreground hover:underline" data-testid="force-pin-logout">
          Esci
        </button>
      </div>
    </div>
  );
}
